import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    //이체정보
    trsaccInfo: {
      //출금계좌정보
      drwotInfo: {
        acno: "", //출금계좌번호
        acnoAls: "", //출금계좌별명
        cncycd: "", //출금통화코드
        ovsesCustOcntryName: "", //고객명
        drwotAbilAmt: 0, //출금가능금액
        dailyTrsaccAcamtRmainLimt: 0, //1일이체잔여한도
        pwdUuid: "", //비밀번호uuid
      },
      //입금계좌정보
      mnrcvInfo: [],
    },
    //입금정보(임시)
    mnrcvTmp: {
      trsaccDstcd: "", //이체구분 (01: 당행, 02: 외화)
      acno: "", //입금계좌번호
      acnoAls: "", //입금계좌별명
      cncycd: "", //입금통화코드
      drwotRmark: "", //송금메모
      mnrcvRmark: "", //수취인통장표시내용
      mnrcvAmt: 0, //입금금액
      fxTranzAmt: 0, //출금예정금액
      fxTranz: "01", //FX 환산 (01: 입금->출금금액 환산, 02: 출금->입금금액 환산)
    },

    //이체예비거래
    trasaccInptPro1: {},
    //이체본거래
    trasaccInptPro2: {},

    //생체정보검증정보
    lvbdInfoValdnInfo: {
      lvbdInfoRegiYn: "", //생체정보등록여부 (0:미등록, 1:등록)
      lvbdInfoValdnNcsrYn: "", //생체정보검증필요여부 (0:불필요, 1:필요)
      valdnId: "", //검증ID
    },

    //이체그룹정보
    trsaccGrpList: {
      trsaccGrpCnt: 0,
      data: [
        //trsaccGrpTemplate
      ],
    },
    //이체그룹정보(단건)
    trsaccGrpInfo: {},

    //이체그룹정보 양식
    trsaccGrpTemplate: {
      mgtSerno: 0, //관리일련번호
      trsaccGroupName: "", //이체그룹명
      regiYMS: "", //등록일시
      detailCnt: 0, //이체그룹계좌개수
      detail: [
        //trsaccGrpDetailTemplate
      ],
    },
    //이체그룹정보(단건) 양식
    trsaccGrpDetailTemplate: {
      regiSerno: 0, //등록일련번호
      dpstrName: "", //예금주명
      mgtAcno: "", //관리계좌번호
      cncycd: "", //통화코드
      drwotAcnMemoCtnt: "", //출금계좌메모내용
      mnrcvAcnMemoCtnt: "", //입금계좌메모내용
      disabled: false,
    },
    //이체그룹목록조회
    RBF0605S40: {},
  };
};

const trsaccInfoInpt = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    //이체정보
    getTrsaccInfo: state => {
      return state.trsaccInfo;
    },
    //출금정보
    getTrsaccDrwotInfo: state => {
      return state.trsaccInfo.drwotInfo;
    },
    //이체그룹정보
    getTrsaccGrpInfo: state => {
      return state.trsaccGrpInfo;
    },
    //이체그룹정보(양식)
    getTrsaccGrpListTemplate: state => {
      return state.trsaccGrpTemplate;
    },
    //이체그룹정보(단건) 양식
    getTrsaccGrpDetailTemplate: state => {
      return state.trsaccGrpDetailTemplate;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    //이체정보 초기화
    setTrsaccInfo_init: state => {
      state.trsaccInfo = getDefaultState().trsaccInfo;
    },
    //입금계좌정보(임시) 초기화
    setMnrcvTmp_init: state => {
      state.mnrcvTmp = getDefaultState().mnrcvTmp;
    },
    //이체그룹정보 초기화
    setTrsaccGrpList_init: state => {
      state.trsaccGrpList = getDefaultState().trsaccGrpList;
    },
    //이체그룹정보(단건) 초기화
    setTrsaccGrpInfo_init: state => {
      state.trsaccGrpInfo = getDefaultState().trsaccGrpInfo;
    },
    //이체정보
    setTrsaccInfo: (state, payload) => {
      if (payload.mnrcvInfo != null && payload.mnrcvInfo.length > 0) {
        payload.mnrcvCnt = payload.mnrcvInfo.length;
      } else {
        payload.mnrcvCnt;
      }

      state.trsaccInfo = payload;
    },
    //이체(입금정보) 추가
    addTrasccMnrcvInfo: (state, payload) => {
      if (payload != null) {
        state.trsaccInfo.mnrcvInfo.push(payload);
      }
    },
    //이체(입금정보) 다건 추가
    addTrasccMnrcvMltlInfo: (state, payload) => {
      if (payload != null) {
        if (payload.acno.indexOf("@@") > -1) {
          let acnoCnt = payload.acno.split("@@").length;

          for (let i = 0; i < acnoCnt; i++) {
            let mnrcvInfo = {
              trsaccDstcd: payload.trsaccDstcd.split("@@")[i], //이체구분 (01: 당행, 02: 외화)
              acno: payload.acno.split("@@")[i], //입금계좌번호
              acnoAls: payload.acnoAls.split("@@")[i], //입금계좌별명
              cncycd: payload.cncycd.split("@@")[i], //입금통화코드
              drwotRmark: payload.drwotRmark.split("@@")[i], //송금메모
              mnrcvRmark: payload.mnrcvRmark.split("@@")[i], //수취인통장표시내용
              mnrcvAmt: 0, //입금금액
              fxTranzAmt: 0, //출금예정금액
            };
            state.trsaccInfo.mnrcvInfo.push(mnrcvInfo);
          }
        } else {
          state.trsaccInfo.mnrcvInfo.push(payload);
        }
      }
    },
    //이체(입금정보) 수정
    modTrasccMnrcvInfo: (state, payload) => {
      if (payload > -1) {
        state.trsaccInfo.mnrcvInfo[payload] = _.cloneDeep(state.mnrcvTmp);
      }
    },
    //이체(입금정보) 삭제
    delTrasccMnrcvInfo: (state, payload) => {
      if (payload > -1) {
        state.trsaccInfo.mnrcvInfo.splice(payload, 1);
      }
    },
    //입금계좌정보(임시) 설정
    setMnrcvTmp: (state, payload) => {
      if (payload > -1) {
        state.mnrcvTmp = _.cloneDeep(state.trsaccInfo.mnrcvInfo[payload]);
      }
    },
    //이체그룹정보 수정
    setTrsaccGrpList: (state, payload) => {
      if (payload.mgtSerno) {
        let idx = state.trsaccGrpList.data.findIndex(item => {
          return item.mgtSerno == payload.mgtSerno;
        });

        if (payload.detailCnt == 0) {
          state.trsaccGrpList.data.splice(idx, 1);
          state.trsaccGrpList.trsaccGrpCnt = state.trsaccGrpList.data.length;
        } else {
          state.trsaccGrpList.data[idx] = payload;
        }
      }
    },
  },
  actions: {
    //이체정보 초기화
    ACT_setTrsaccInfo_init: context => {
      context.commit("setTrsaccInfo_init");
    },
    //입금계좌정보(임시) 초기화
    ACT_setMnrcvTmp_init: context => {
      context.commit("setMnrcvTmp_init");
    },
    //이체그룹정보 초기화
    ACT_setTrsaccGrpList_init: context => {
      context.commit("setTrsaccGrpList_init");
    },
    //이체그룹정보(단건) 초기화
    ACT_setTrsaccGrpInfo_init: context => {
      context.commit("setTrsaccGrpInfo_init");
    },
    //이체정보
    ACT_setTrsaccInfo: (context, payload) => {
      context.commit("setTrsaccInfo", payload);
    },
    //이체(입금정보) 추가
    ACT_addTrasccMnrcvInfo: (context, payload) => {
      context.commit("addTrasccMnrcvInfo", payload);
    },
    //이체(입금정보) 다건 추가
    ACT_addTrasccMnrcvMltlInfo: (context, payload) => {
      context.commit("addTrasccMnrcvMltlInfo", payload);
    },
    //이체(입금정보) 수정
    ACT_modTrasccMnrcvInfo: (context, payload) => {
      context.commit("modTrasccMnrcvInfo", payload);
    },
    //이체(입금정보) 삭제
    ACT_delTrasccMnrcvInfo: (context, payload) => {
      context.commit("delTrasccMnrcvInfo", payload);
    },
    //입금계좌정보(임시) 설정
    ACT_setMnrcvTmp: (context, payload) => {
      context.commit("setMnrcvTmp", payload);
    },
    //이체그룹정보 수정
    ACT_setTrsaccGrpList: (context, payload) => {
      context.commit("setTrsaccGrpList", payload);
    },
  },
};

export default trsaccInfoInpt;
